// #2843 -- FVD re-keys a whole class. R7/CDS 2026-09-18 17:00: class 1
// "Welcome Training Level Test of Choice" moved from sngClassID-1 to
// sngClassID-33 inside FVD. foxbox/ingest did the right thing (tombstoned the
// -1 day-sheet rows, wrote -33 rows), and reconcile did what it is designed to
// do (docs/score/class-move-orphan-runbook.md): minted a fresh class + unscored
// rides under -33 and KEPT the scored -1 rides, because a ride with score
// sheets is never purged (#875, #1176). The result is two score-class rows
// with the same classNumber: one carrying every score (-1, no longer in FVD),
// one carrying the same riders with none (-33, the live one). Publish Results
// then showed -33 as "9 ride(s) not yet closed", i.e. as though class 1 never
// ran, with nothing pointing at the scored twin.
//
// This is the pure detector: group the show's visible classes by classNumber
// and, for each class that shares its number, say who the others are and how
// far along each one is. classNumber is unique per FVD show (R7/CDS scan,
// 237 class rows, class 1 the only repeat), so a repeat is never legitimate.
import { RIDE_STATUSES, DERIVED_RIDE_STATUSES } from "score-common";

const keyOf = (c) => {
  const n = c?.classNumber;
  return n == null || `${n}`.trim() === "" ? null : `${n}`.trim();
};

// A ride is "closed" when scratched or confirmed/final: the same test
// PublishResults' classIncompleteInfo applies.
function closedCount(rides, rideStatusByRideId) {
  return (rides || []).filter((r) => {
    if (r.status === RIDE_STATUSES.SCRATCHED) return true;
    const derived = rideStatusByRideId?.[r.id];
    return derived === DERIVED_RIDE_STATUSES.CONFIRMED || derived === DERIVED_RIDE_STATUSES.FINAL;
  }).length;
}

// Returns { [classId]: { classNumber, self: {rides, closed}, others: [{ classId, rides, closed }] } }
// holding only classes that share a classNumber with another class.
export function findClassNumberTwins(classes, ridesByClassId, rideStatusByRideId) {
  const groups = new Map();
  for (const c of classes || []) {
    const k = keyOf(c);
    if (k == null) continue;
    if (!groups.has(k)) groups.set(k, []);
    groups.get(k).push(c);
  }
  const out = {};
  for (const [classNumber, members] of groups) {
    if (members.length < 2) continue;
    const stat = (c) => {
      const rides = ridesByClassId?.[c.id] || [];
      return { classId: c.id, rides: rides.length, closed: closedCount(rides, rideStatusByRideId) };
    };
    for (const c of members) {
      const { rides, closed } = stat(c);
      out[c.id] = {
        classNumber,
        self: { rides, closed },
        others: members.filter((o) => o.id !== c.id).map(stat),
      };
    }
  }
  return out;
}
